var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoursesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "84A09EC6-11C7-4FC3-9E95-946B333FCF31") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.9690527,13.3596047 L15.0801878,12.1427301 C15.2538027,11.9525935 15.5558926,12.0856891 15.5558926,12.3594859 L15.5558926,17.8886597 C15.5558926,18.896384 14.8093486,19.7139716 13.8891898,19.7139716 L1.66670278,19.7139716 C0.746543952,19.7139716 0,18.896384 0,17.8886597 L0,4.50303945 C0,3.4953152 0.746543952,2.67772759 1.66670278,2.67772759 L11.1634363,2.67772759 C11.4099694,2.67772759 11.5349721,3.00476263 11.3613573,3.19870202 L10.2502221,4.41557659 C10.1981376,4.47261759 10.1286917,4.50303945 10.0523011,4.50303945 L1.66670278,4.50303945 L1.66670278,17.8886597 L13.8891898,17.8886597 L13.8891898,13.5725577 C13.8891898,13.4927004 13.9169682,13.4166457 13.9690527,13.3596047 Z M19.4066705,5.68568943 L10.2884174,15.6716664 L7.14946045,16.0519397 C6.23971852,16.1622189 5.46539619,15.3218149 5.56609282,14.3178934 L5.91332256,10.8802228 L15.0315757,0.894245797 C15.8267318,0.0234199313 17.1114818,0.0234199313 17.9031657,0.894245797 L19.4031982,2.53702647 C20.1983543,3.40785234 20.1983543,4.81866629 19.4066705,5.68568943 L19.4066705,5.68568943 Z M15.9760406,6.86073393 L13.9586358,4.65134604 L7.50710709,11.7206268 L7.25362938,14.2038114 L9.52103961,13.9262119 L15.9760406,6.86073393 Z M18.2260893,3.8299557 L16.7260568,2.18717503 C16.5836926,2.03126298 16.3510487,2.03126298 16.2121568,2.18717503 L15.1392169,3.36221954 L17.1566217,5.57160743 L18.2295616,4.39656293 C18.3684535,4.23684814 18.3684535,3.98586776 18.2260893,3.8299557 L18.2260893,3.8299557 Z",
    id: "courses-path"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Courses",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2-1-1-Manage-Users",
    transform: "translate(-36.000000, -108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu.group",
    transform: "translate(16.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Courses",
    transform: "translate(0.000000, 0.360409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Regular/edit",
    transform: "translate(20.000000, 14.804749)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#courses-path"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uD83C\\uDFA8-Icon-Fill",
    fill: "currentColor",
    xlinkHref: "#courses-path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursesIcon);
export default __webpack_public_path__ + "static/media/courses-icon.fbc4c2bd.svg";
export { ForwardRef as ReactComponent };